import Joyride, { type CallBackProps } from "react-joyride";
import { joyrideLocale, joyrideStyles } from "./joyrideConfig";
import { documentEditTourSteps } from "./documentEditTourSteps";

type DocumentEditTourProps = {
  run: boolean;
  onCallback: (data: {
    status?: string;
    type?: string;
    index?: number;
    action?: string;
  }) => void;
};

export function DocumentEditTour({ run, onCallback }: DocumentEditTourProps) {
  const handleCallback = (data: CallBackProps) => {
    const { status, type, index, action } = data;
    onCallback({ status, type, index, action });
  };

  return (
    <Joyride
      steps={documentEditTourSteps}
      run={run}
      continuous
      showProgress
      showSkipButton
      callback={handleCallback}
      locale={joyrideLocale}
      styles={joyrideStyles}
    />
  );
}

export { useDocumentEditTour } from "./useDocumentEditTour";
